/* eslint-disable max-classes-per-file */

export class NotFoundError extends Error {
  name = 'NotFoundError';

  title = '404';

  icon = 'search';

  constructor(
    message: string = "Sorry, we didn't find what you're looking for."
  ) {
    super(message);
  }
}

export class UnauthorizedError extends Error {
  title = 'Unauthorized';

  icon = 'error_outline';
}

export class GraphQLError extends Error {
  title = 'GraphQL Error';

  icon = 'error_outline';

  constructor(apolloError: any) {
    super();
    Object.assign(this, apolloError);
  }
}
